import { Outlet } from 'react-router';
import { useState, useEffect, useCallback } from 'react';
import Sidebar from '@/features/members/components/navigation/Sidebar';
import Header from '@/features/members/components/navigation/Header';
import useMediaQuery from '@/hooks/useMediaQuery';

const ToggleButton = ({ onClick }: { onClick: () => void }) => (
  <button
    onClick={onClick}
    className="absolute top-[12px] left-4 bg-primary p-2 rounded text-white z-50"
  >
    ☰
  </button>
);

export default function MembersPortalLayout() {
  const isDesktop = useMediaQuery('(min-width: 768px)');
  const [isSidebarOpen, setIsSidebarOpen] = useState(isDesktop);

  useEffect(() => {
    setIsSidebarOpen(isDesktop);
  }, [isDesktop]);

  const toggleSidebar = useCallback(() => {
    setIsSidebarOpen((prev) => !prev);
  }, []);

  return (
    <div className="flex h-screen">
      <Sidebar toggleSidebar={toggleSidebar} isOpen={isSidebarOpen} isDesktop={isDesktop} />

      <div className="flex flex-col flex-1 relative">
        <ToggleButton onClick={toggleSidebar} />
        <Header />
        <main className="p-4">
          {' '}
          <Outlet />
        </main>
      </div>
    </div>
  );
}
